<div dotCmsPageContext>
  <custom-dot-cms-layout>
    <!-- Todo: Development for header and footer -->
    <ng-container *ngIf="false; else layoutGrid"> </ng-container>
  </custom-dot-cms-layout>

  <ng-template #layoutGrid>
    <custom-dot-cms-layout-grid></custom-dot-cms-layout-grid>
  </ng-template>
</div>
